module.exports = __webpack_public_path__ + "img/n1.1ed458dc.jpg";